import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import { ErrorMessage } from '../../common';
import 'react-datepicker/dist/react-datepicker.css';
import { getCSRFToken, ROOT_URL } from '../../../config';
import { getErrorMessages } from '../../../utils';
import { TPageNotification } from '../../../types';


export type TInductionSessionFormData = {
    service: string;
    slots: number;
    duration: string;
    start: Date;
    comment: string
}

type AddSessionInductionProps = {
    notification: TPageNotification;
    closeModal: () => void;
    defaultDateTime: string;
    currentDate: Date;
    scheduledEventsList: TInductionSessionFormData[];
    reloadData: () => void;
}

type AddSessionInductionState = {
    commentText: string;
    sending: boolean;
    error: any;
    inductionSessionFormData: TInductionSessionFormData;
    scheduledEventsList: TInductionSessionFormData[];
}
export class AddInductionSession extends Component<
    AddSessionInductionProps,
    AddSessionInductionState
> {

    state = {
        commentText: '',
        sending: false,
        error: '',
        inductionSessionFormData: {
            service: 'general', // BER-1191 Allow to create only 'All sectors' induction sessions, set 'general' as default
            slots: 1,
            duration: '00:15:00',
            start: new Date(this.props.defaultDateTime),
            comment: ''
          },
        currentDate: this.props.currentDate,
        scheduledEventsList: this.props.scheduledEventsList,
    }

    inductionServiceChoices = [
        {
            value: 'general',
            label: 'All sectors'
        },{
            value: 'construction',
            label: 'Construction'
        },{
            value: 'driver',
            label: 'Driving'
        }, {
            value: 'hospitality',
            label: 'Hospitality'
        }, {
            value: 'industry',
            label: 'Industrial'
        }, {
            value: 'office',
            label: 'Office'
    }];

    setEvent = () => {
        const headers = { 'X-CSRFToken': getCSRFToken() };
        axios.post(
            `${ROOT_URL}induction-sessions/`,
            {
                    'service': this.state.inductionSessionFormData.service,
                    'slots': this.state.inductionSessionFormData.slots,
                    'duration': this.state.inductionSessionFormData.duration,
                    'start': this.state.inductionSessionFormData.start.toISOString(),
                    'comment': this.state.inductionSessionFormData.comment
                  },
            { headers }
        )
        .then((response => {
            // show success notification
            const content = response.data?.content;
            this.props.notification.success(
                'Success', 'Induction session has been created successfully.'
            );
            this.props.closeModal();
            this.props.reloadData();
            return content;
        }))
        .catch(error => {
            if (error && error.response) {
                    this.setState({ error: getErrorMessages(error) });
                }
                this.setState({
                    sending: false,
                });
        });
    }

    handleInputChange = (e: { target: { name: any; value: any; }; }) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            inductionSessionFormData: {
            ...prevState.inductionSessionFormData,
            [name]: value
          }
        }));
    };

    handleDateTimeChange = (dateTime: Date) => {
      const { inductionSessionFormData } = this.state;
      const updatedFormData = {
        ...inductionSessionFormData,
        start: dateTime
      };
      this.setState({ inductionSessionFormData: updatedFormData });
    };

    render() {
        const { inductionSessionFormData } = this.state;
        return (
            <div>
                <div className="modal-dialog add-induction-session-container">
                    <div className="popup-header">
                        <div
                            className="popup-header-dismiss"
                            onClick={this.props.closeModal}
                        >
                            <i className="icon icon-close" />
                        </div>
                        <h1>
                            New induction session
                        </h1>
                    </div>
                    <form noValidate={true} name="inductionSessionForm" onSubmit={this.setEvent}>
                        <div className="group-service">
                            <label htmlFor="service">Session Service</label>
                            <select
                                className="form-control"
                                name="service"
                                value={inductionSessionFormData.service}
                                onChange={this.handleInputChange}
                                required={true}
                                disabled={true}
                            >
                                {this.inductionServiceChoices.map((service, key) => (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <option key={key} value={service.value}>
                                        {service.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="group-slots">
                            <label htmlFor="slots">Total Slots</label>
                            <input
                                type="number"
                                className="form-control"
                                name="slots"
                                min="0"
                                step="1"
                                value={inductionSessionFormData.slots}
                                onChange={this.handleInputChange}
                                required={true}
                            />
                        </div>
                        <div className="group-time induction-session-datepicker">
                            <label htmlFor="time">Date and time</label>
                            <DatePicker
                                className="bootstrap3timeinput form-control"
                                id="start_time"
                                name="time"
                                showTimeSelect={true}
                                timeFormat="HH:mm"
                                dateFormat="dd/MM/yyyy p"
                                timeIntervals={15}
                                selected={inductionSessionFormData.start}
                                onChange={dateTime => this.handleDateTimeChange(dateTime)}
                                required={true}
                                calendarStartDay={1}
                            />
                            <span className="input-group-addon">
                              <i className="icon icon-calendar-2"/>
                            </span>
                        </div>
                        <div className="group-duration">
                            <label htmlFor="duration">Duration</label>
                            <input
                                type="text"
                                className="form-control"
                                name="duration"
                                id="duration"
                                placeholder="Duration"
                                value={inductionSessionFormData.duration}
                                onChange={this.handleInputChange}
                                required={true}
                            />
                            <span className="input-group-addon">
                              <i className="icon icon-hourglass-1"/>
                            </span>
                        </div>
                        <div className="group-comment">
                          <textarea
                              className="form-control"
                              id="comment"
                              placeholder="Comment"
                              name="comment"
                              value={inductionSessionFormData.comment}
                              onChange={this.handleInputChange}
                          />
                        </div>
                        <div className="modal-bottom-bar">
                            <button
                                className="table-action-button"
                                type="button"
                                onClick={this.setEvent}
                                disabled={
                                    this.state.sending || this.state.inductionSessionFormData.service === ''
                                }
                            >
                                {this.state.sending
                                    ? 'Creating...'
                                    : 'Create'}
                            </button>
                        </div>
                    </form>
                </div>
                {this.state.error ? (
                    <ErrorMessage message={this.state.error}/>
                ) : false}
            </div>
        );
    }
}
